import React, { Component, Fragment } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import API from '../../../utils/API';
import Form from './form';
import CreateFormModal from './modals/addFormModal';
import DeleteFormModal from './modals/deleteDefaultModal';
import ViewsContainer from '../../../components/views/ViewsContainer';
import FormsTemplateCenter from '../../../sections/event/forms/modals/FormsTemplateCenter';
import TabsContainer from '../../../components/views/TabsContainer';
import ActionButtonContainer from '../../../components/views/ActionButtonContainer';
import ViewsTable from '../../../components/tables/ViewsTable';
import SectionHeader from '../../../components/views/SectionHeader';
import RenameFormModal from './modals/renameFormModal';
import DuplicateFormModal from './modals/duplicateFormModal';

let batchActionCB;
class EventForms extends Component {
	constructor(props) {
		super(props);
		const customFieldColumns = {
			name: 'Name',
			type: 'Type',
			enableSubmissionReview: 'Confirmation Required',
			confirmationEmailName: 'Confirmation Email',
			pageCount: 'Page Count',
			createdAt: 'Created At',
			updatedAt: 'Updated At'
		};

		const defaultFieldTypes = {
			name: 'text',
			type: 'text',
			description: 'text',
			status: 'text',
			enableSubmissionReview: 'boolean',
			confirmationEmailName: 'text',
			pageCount: 'number',
			createdAt: 'date',
			updatedAt: 'date'
		};

		const fieldCategories = {
			basics: {
				title: 'Basics',
				columns: [
					'name',
					'type',
					'enableSubmissionReview',
					'confirmationEmailName',
					'pageCount',
					'createdAt',
					'updatedAt'
				]
			},
		};

		const toggledColumns = {};
		const normalizedColumns = Object.keys(customFieldColumns).map((cfc) => {
			toggledColumns[cfc] = true;
			return {
				label: customFieldColumns[cfc],
				key: cfc,
				value: cfc,
				type: (defaultFieldTypes && defaultFieldTypes[cfc]) || typeof defaultFieldTypes[cfc],
				sortAsc: false,
				sortDesc: false
			};
		});


		delete toggledColumns[Object.keys(defaultFieldTypes)[0]];

		this.state = {
			categoryColumns: fieldCategories,
			loading: true,
			checkedForms: [],
			addFormModalOpen: false,
			columns: customFieldColumns,
			columnTypes: defaultFieldTypes,
			deletedForms: [],
			formsViews: [],
			deleteFormsModalOpen: false,
			toggleFormTemplateCenter: false,
			platformFormTemplates: [],
			normalizedColumns: normalizedColumns,
			toggledColumns: toggledColumns,
			selectedSection: 0,
			searchText: '',
			selectedRow: '',
			toggleRenameFormModal: false,
			deleteSingleFormModalOpen: false,
			toggleDuplicateFormModal: false,

		};
	}

	async componentDidMount() {
		const { program, programId, orgId } = this.props;

		let emailTemplates = program.eventDefaults.emails;
		let forms = this.props.forms;

		forms = forms.map((f) => {
			if (f.confirmationEmail && f.confirmationEmail !== '') {
				let email = emailTemplates.find(e => {
					let campaignId = e._id;
					let formConfirmationEmail = f.confirmationEmail;
					if (campaignId === formConfirmationEmail) {
						return e;
					}
				});

				if (email) {
					f.confirmationEmailName = email.name;

				} else {

					f.confirmationEmailName = 'N/A';
				}


			} else {
				f.confirmationEmailName = 'N/A';

			}

			return f;
		})

		await API().get(`/Organizations/${orgId}/getPlatformFormTemplates`).then((res) => {
			if (res.data) {
				if (res.data.formTemplates) {
					this.setState({ formTemplates: res.data.formTemplates });
				}

			}
		}).catch((err) => {
			console.log(err);
		}
		);
	}


	deleteCheckedForms = (formIds, batchActionCB) => {
		this.props.deleteForms(formIds, () => {
			batchActionCB && batchActionCB('delete');
			this.setState({ checkedForms: {} })
		});
	};

	toggleDeleteForms = () => {
		this.setState({ deleteFormsModalOpen: !this.state.deleteFormsModalOpen });
	};

	deleteSingleForm(formId) {
		this.props.deleteForms([formId], () => {
			this.setState({ deleteSingleFormModalOpen: false });
		});
	}

	toggleDeleteSingleForm = (formIds) => {
		const { deleteSingleFormModalOpen } = this.state;
		this.setState({ deleteSingleFormModalOpen: !deleteSingleFormModalOpen, selectedRow: formIds });
	};

	toggleRenameFormModal = (formId) => {
		const { toggleRenameFormModal } = this.state;
		this.setState({ toggleRenameFormModal: !toggleRenameFormModal, selectedRow: formId });
	};

	toggleDuplicateFormModal = (formId) => {
		const { toggleDuplicateFormModal } = this.state;
		this.setState({ toggleDuplicateFormModal: !toggleDuplicateFormModal, selectedRow: formId });
	}

	addForm = (form, cb) => {
		this.props.addForm(form, () => {
			batchActionCB && batchActionCB('update');
			this.toggleAddForm();
		});
	};

	duplicateForm = (formId, name, callback) => {
		this.props.duplicateForm(formId, name, () => {
			batchActionCB && batchActionCB('update');
			callback();
		});
	}

	updateFormName = (formName) => {
		const form = this.props.forms.find((f) => f._id === this.state.selectedRow);
		if (form) {
			form.name = formName;
			this.props.saveForm(form, () => {
				this.setState({
					forms: [...this.props.forms]
				}, () => {
					this.toggleRenameFormModal();
				});
			});
		}
	};


	toggleAddForm = (cb) => {
		batchActionCB = cb;
		this.setState({ addFormModalOpen: !this.state.addFormModalOpen });
	};

	toggleFormTemplateCenter = () => {
		this.setState({ toggleFormTemplateCenter: !this.state.toggleFormTemplateCenter });
	}
	updateSelected = (selectedIndex) => {
		this.setState({ selectedSection: selectedIndex, checkedForms: {} });
	};
	searchEntries = (searchText) => {
		this.setState({
			searching: searchText != '' ? true : false,
			searchText: searchText ? searchText : '',
		});
	};
	sortData = (column, sortAsc, sortDesc) => {
		const { normalizedColumns } = this.state;
		let nc = normalizedColumns;
		nc = nc.map((col) => {
			if (col.key == column.key) {
				col.sortAsc = sortAsc;
				col.sortDesc = sortDesc;
			} else {
				col.sortAsc = false;
				col.sortDesc = false;
			}
			return col;
		});

		this.setState({
			normalizedColumns: nc,
			selectedColumnSort: column,
			sortDesc: sortDesc == false ? true : false
		});
	};
	checkEntry = (entryId) => {
		const checked = this.state.checkedForms;
		checked[entryId] ? delete checked[entryId] : (checked[entryId] = true);
		this.setState({
			checkedForms: checked
		});
	};

	checkAllEntries = (entryIds) => {
		let checked = this.state.checkedForms;
		entryIds.length > 0
			? entryIds.forEach((entryId) => {
				checked[entryId] = true;
			})
			: (checked = {});

		this.setState({
			checkedForms: checked
		});
	};

	uncheckEntries = () => {
		this.setState({
			checkedForms: {}
		});

	}
	updatedCheckedForms = (checked) => {
		this.setState({ checkedForms: checked });
	};

	render() {
		const { forms, program, orgId, programId, readOnly } = this.props;
		const {
			columns,
			deleteFormsModalOpen,
			checkedForms,
			addFormModalOpen,
			toggleFormTemplateCenter,
			formTemplates,
			toggledColumns,
			normalizedColumns,
			selectedSection,
			searchText,
			selectedColumnSort,
			sortDesc,
			deleteSingleFormModalOpen,
			toggleRenameFormModal,
			toggleDuplicateFormModal
		} = this.state;

		let mainAction = [{type: 'button', label: 'Add Form', onClick: this.toggleFormTemplateCenter }];
		let batchActions = [
			{
				label: 'Delete',
				iconClass: 'las la-trash-alt',
				class: 'danger',
				onClick: this.toggleDeleteForms
			}
		];
		let searchEnabled = true;
		let checkedEntryCount = Object.keys(this.state.checkedForms).length;
		let data = this.props.forms;
		let checkedRows = this.state.checkedForms;
		const form = data.find((f) => f._id === this.state.selectedRow)


		if (searchText.length > 0) {
			const searchTerms = searchText.toLowerCase().split(' ');
			searchTerms.forEach((term) => {
				if (term != '') {
					data = data.filter((entry) => {
						let found = false;
						Object.keys(columns).forEach((key) => {
							if (term != '' && entry[key] && entry[key].toString().toLowerCase().includes(term)) {
								found = true;
							}
						});
						return found;
					});
				}
			});
		}

		switch (selectedSection) {

			case 1:
				data = data.filter((p) => p.type === 'registration');
				break;
			case 2:
				data = data.filter((p) => p.type === 'general');
				break;
			default:
				break;
		}
		let entriesLength = data.length;

		if (selectedColumnSort) {
			data = data.sort((a, b) => {
				const columnType = selectedColumnSort.type || typeof a[selectedColumnSort.key];
				if (a[selectedColumnSort.key] && b[selectedColumnSort.key]) {
					switch (columnType) {
						case 'string':
							return a[selectedColumnSort.key]
								.toLowerCase()
								.trim()
								.localeCompare(b[selectedColumnSort.key].toLowerCase().trim());
						case 'number':
							return a[selectedColumnSort.key] - b[selectedColumnSort.key];
						case 'date':
							return (
								new Date(a[selectedColumnSort.key]).getTime() -
								new Date(b[selectedColumnSort.key]).getTime()
							);
						case 'time':
							return (
								new Date(a[selectedColumnSort.key]).getTime() -
								new Date(b[selectedColumnSort.key]).getTime()
							);
						case 'boolean':
							const a1 = a[selectedColumnSort.key] ? 'yes' : 'no';
							const b1 = b[selectedColumnSort.key] ? 'yes' : 'no';
							return a1.localeCompare(b1);
						default:
							return a[selectedColumnSort.key]
								.toLowerCase()
								.trim()
								.localeCompare(b[selectedColumnSort.key].toLowerCase().trim());
					}
				} else if (a[selectedColumnSort.key]) {
					return 1;
				}
				return -1;
			});

			data = sortDesc ? data.reverse() : data;
		}
		const checkedCount = Object.keys(checkedForms).length;
		let emailTemplates = program.eventDefaults.emails;
		let formsList = this.props.forms;

		formsList = formsList.map((f) => {
			if (f.confirmationEmail && f.confirmationEmail !== '') {
				let email = emailTemplates.find(e => {
					let campaignId = e._id;
					let formConfirmationEmail = f.confirmationEmail;
					if (campaignId === formConfirmationEmail) {
						return e;
					}
				});

				if (email) {
					f.confirmationEmailName = email.name;
				} else {

					f.confirmationEmailName = 'N/A';
				}
			} else {
				f.confirmationEmailName = 'N/A';

			}
			return f;
		})
		return (
			<Switch>
				<Route exact path={`/${orgId}/programs/${programId}/forms`}>
					<Fragment>
						<SectionHeader
							title="Default Forms"
							description="Forms listed here will be added to all approved events. Create and manage registration and check-in forms. Add forms to pages to create a custom registration website."
							readOnly={false}
							enableDownloadViews={true}
							type={'Form'}
							referenceCollection={'Programs'}
							referenceId={programId}
							breadcrumbs={[
								{
									name: `${program.name}`,
								}
							]}
							style={{ paddingBottom: 0 }}
							enableLastLink={true}
						>
						</SectionHeader>
						<TabsContainer
							tabs={[{ title: 'All Forms' }, { title: 'Registration Forms' }, { title: 'General Forms' }]}
							updateSelected={this.updateSelected}
							selectedIndex={selectedSection}
						/>

						<ActionButtonContainer
							mainActions={mainAction}
							searchEnabled={searchEnabled}
							searchEntries={this.searchEntries}
							enabledViewSelection={false}
						/>
						<div className='flex h-100 hasHeader'>
							<ViewsTable
								title={"Form"}
								columns={normalizedColumns}
								toggledColumns={toggledColumns}
								data={data}
								mainColumnActive={true}
								checked={checkedRows}
								checkRow={this.checkEntry}
								checkAllRows={this.checkAllEntries}
								sortData={this.sortData}
								defaultSort={'name'}
								sortDirection={'desc'}
								rowSettings={[
									{
										label: <span><i className='las la-pen mr-10'></i>Rename Form</span>,
										onClick: this.toggleRenameFormModal
									},
									{
										label: <span><i className='las la-copy mr-10'></i>Duplicate Form</span>,
										onClick: this.toggleDuplicateFormModal
									},
									{
										label: <span><i className='las la-trash mr-10'></i>Delete Form</span>,
										onClick: this.toggleDeleteSingleForm
									}
								]}
							/>
						</div>
						<ActionButtonContainer
							batchActions={batchActions}
							checkedEntryCount={checkedEntryCount}
							entriesLength={entriesLength}
							uncheckEntries={this.uncheckEntries}
						/>
						{deleteSingleFormModalOpen &&
							(<DeleteFormModal
								isOpen={deleteSingleFormModalOpen}
								toggle={() => this.toggleDeleteSingleForm()}
								title={`Delete ${checkedCount > 1 ? 'Forms' : 'Form'}`}
								message={`You are about to delete form this is irreversible, would you like to continue?`}
								submit={() =>
									this.deleteSingleForm(this.state.selectedRow, () => {
										this.setState({ checkedForms: {}, deleteSingleFormModalOpen: false });
									})}
							/>)
						}
						{toggleRenameFormModal && <RenameFormModal
							toggle={this.toggleRenameFormModal}
							isOpen={toggleRenameFormModal}
							name={form.name}
							formId={form._id}
							form={form}
							eventId={programId}
							orgId={orgId}
							update={this.updateFormName}
						/>}
						{toggleFormTemplateCenter && (
							<FormsTemplateCenter
								isOpen={toggleFormTemplateCenter}
								orgId={orgId}
								templates={[]}//localTemplates
								platformTemplates={this.state.formTemplates}
								toggle={this.toggleFormTemplateCenter}
								addForm={this.addForm}
								account={this.props.account}
								programId={programId}
								availableEmails={program.eventDefaults.emails.map((em) => {
									return {
										value: em._id,
										label: em.name
									}
								})}
								addProgramForm={this.props.addForm}
							/>
						)}
						{toggleDuplicateFormModal && <DuplicateFormModal
							toggle={this.toggleDuplicateFormModal}
							isOpen={toggleDuplicateFormModal}
							name={form.name}
							formId={form._id}
							programId={programId}
							orgId={orgId}
							duplicateForm={this.props.duplicateForm}

						/>}
						{deleteFormsModalOpen &&
							(<DeleteFormModal
								isOpen={deleteFormsModalOpen}
								toggle={() => this.toggleDeleteForms()}
								title={`Delete ${checkedCount > 1 ? 'Forms' : 'Form'}`}
								message={`You are about to delete ${checkedCount} ${checkedCount > 1
									? 'forms'
									: 'form'}, this is irreversible,
						would you like to continue?`}
								submit={() =>
									this.deleteCheckedForms(Object.keys(checkedForms), () => {
										this.setState({ checkedForms: {}, deleteFormsModalOpen: false });
									})}
							/>)
						}
						{addFormModalOpen && <CreateFormModal
							isOpen={addFormModalOpen}
							program={program}
							programId={programId}
							readOnly={readOnly}
							handleSubmit={this.props.addForm}
							orgId={this.props.orgId}
							toggle={this.toggleAddForm}
						/>}
					</Fragment>
				</Route>
				<Route path={`/${orgId}/programs/${programId}/forms/:formId`}>
					<Form
						program={program}
						programId={programId}
						readOnly={readOnly}
						orgId={this.props.orgId}
						forms={forms}
						fields={this.props.fields}
						addNewField={this.props.addNewField}
						saveForm={this.props.saveForm}
						duplicateForm={this.duplicateForm}
						deleteForms={this.props.deleteForms}
						updatePages={this.props.updatePages}
						eventFields={this.props.eventFields}
						attendeeFields={this.props.attendeeFields}
					/>
				</Route>
			</Switch>
		);
	}
}

export default withRouter(EventForms);
